export default __webpack_public_path__ + "static/media/home3.159af410.jpg";